import service from "../api/service.js";

let initApp = {};
export let Space3DURL = "";
initApp.get3DSpaceURL = async function (widget) {
  return new Promise((resolve, reject) => {
    try {
      window.requirejs(
        ["DS/i3DXCompassServices/i3DXCompassServices"],
        function (i3DXCompassServices) {
          i3DXCompassServices.getServiceUrl({
            serviceName: "3DSpace",
            
            onComplete: function (urls) {
              const currentHost = window.location.hostname.toLowerCase();

              const result = urls.find((item) => {
                if (!item.url) return false;

                // On-Premise
                if (item.platformId === "OnPremise") {
                  return (
                    new URL(item.url).hostname.toLowerCase() === currentHost
                  );
                }

                // Cloud
                const currentTenant = currentHost
                  .split(".")[0]
                  .split("-")[0]
                  .toLowerCase();

                return item.platformId.toLowerCase() === currentTenant;
              });

              Space3DURL = result ? result.url : null;

              console.log("Selected 3DSpace URL:", Space3DURL);

              resolve(Space3DURL);
            },

            onFailure: function (err) {
              reject(err);
            },
          });
        },
      );
    } catch (e) {
      reject(e);
    }
  });
};

initApp.userCtxCollabspaces = async function (widget) {
  try {
    let data = await service.EnoviaService().getCollabspaces();
    let role = data.data.preferredcredentials.role.name;
    let organization = data.data.preferredcredentials.organization.name;
    let collabspace = data.data.preferredcredentials.collabspace.name;
    let ctx = `ctx::${role}.${organization}.${collabspace}`;
    const formattedOutput = extractCollabspaceInfo(data);
    const formattedArray = formattedOutput.map((item) => ({
      label: item,
      value: `ctx::${item}`,
    }));
    widget.addPreference({
      name: "ctx_credentials",
      type: "list",
      label: "Credentials",
      defaultValue: ctx,
      options: formattedArray,
    });
    widget.addPreference({
      name: "taskLevel",
      type: "text",
      label: "Task Level",
      defaultValue: 2,
    });
  } catch (err) {
    throw new Error("CTX is missing!");
  }
};

function extractCollabspaceInfo(data) {
  let results = [];
  try {
    data.data.collabspaces.forEach((collabspace) => {
      const spaceName = collabspace.name;
      collabspace.couples.forEach((couple) => {
        const organizationName = couple.organization.name;
        const roleName = couple.role.name;
        results.push(`${roleName}.${organizationName}.${spaceName}`);
      });
    });
  } catch (error) {
    //
  }
  return results;
}

initApp.getCTX = function () {
  try {
    return window.widget ? window.widget.getValue("ctx_credentials") : "";
  } catch (error) {
    //
  }
};

export { initApp as default };
